import { render, staticRenderFns } from "./salesCommission.vue?vue&type=template&id=efe580a8&"
import script from "./salesCommission.vue?vue&type=script&lang=js&"
export * from "./salesCommission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports